import { Box } from '@mui/material';
import AlertDialog from 'components/AlertDialog';
import AllUsersGlobalListeners from 'layout/MainLayout/Listeners/AllUsersGlobalListeners';
import { Outlet } from 'react-router-dom';
import Header from './Header';

// ==============================|| MAIN LAYOUT ||============================== //

const ClientLayout = () => {
  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        <Box component="main" sx={{ width: '100%', flexGrow: 1, p: 0 }}>
          <Outlet />
          <AlertDialog />
        </Box>
      </Box>
      <AlertDialog />
      <AllUsersGlobalListeners />
    </>
  );
};

export default ClientLayout;
